import { trackEvent as trackEventUtil } from "@leafly-com/web-utils";
import startCase from "lodash/startCase";

export enum Category {
  addToBag = "Add to Bag",
  dealsCarouselCard = "deals_carousel_card",
  dealsMenuDealsCard = "Deals Menu Deals Card",
  dealsMenuLoadMoreDeals = "deals_menu_load_more_deals_button",
  dealMenuPhenotypes = "deal_menu_phenotypes",
  dealMenuProductCategories = "deal_menu_product_categories",
  dealsMenuPromotionsCard = "Deals Menu Promotions Card",
  dealsMenuSeeAllLocationsLink = "deals_menu_see_all_locations_link",
  dealMenuStrains = "deal_menu_strains",
  dealsMerchandising = "deals_merchandising",
  homepageSearch = "homepage_search",
  productPage = "Products",
  searchResults = "search_results",
}

export enum Action {
  affiliateLinkClick = "BUY HERE",
  categorySelected = "category_selected",
  click = "click",
  dealsMerchandisingClicked = "deals_merchandising_clicked",
  dealsMerchandisingImpression = "deals_merchandising_impression",
  impression = "impression",
  searchResultClicked = "search_result_clicked",
  searchResultsFiltered = "search_results_filtered",
  searchResultsSorted = "search_shop_results_sorted",
  searchShopNullResults = "search_shop_null_results",
  searchShopResultsFiltered = "search_shop_results_filtered",
}

type Dimension = { [name: string]: number | string };

export const trackEvent = (
  category: Category,
  action: Action,
  label?: string,
  customDimensions?: Dimension
) => trackEventUtil(category, action, label, customDimensions);

export const trackMenuEvent = (
  field: string,
  label: string,
  menuItemId: string | number | null,
  retailType?: any,
  menuItem?: any,
  category?: string | null
) => {
  const renamedFields = {
    Varieties: "Classification",
    Categories: "ProductType",
  } as any;

  let action = startCase(field).replace(/[^A-Za-z0-9]/g, "");

  if (renamedFields[action]) {
    action = renamedFields[action];
  }

  const itemDimensions = {} as any;

  if (menuItem) {
    itemDimensions.menuItemId = menuItem.id || menuItem.menuItemId;
    itemDimensions.brandId = menuItem.brandId || menuItem.brand?.id;
    itemDimensions.productId = menuItem.productId || menuItem.product?.id;
    itemDimensions.strainId = menuItem.strainId || menuItem.strain?.id;
  } else if (menuItemId) {
    itemDimensions.menuItemId = menuItemId;
  }
  trackEventUtil(category || "Dispensary Menu", action, label, itemDimensions);
};

export const trackReviewsEvent = (field: string, label?: string) => {
  const action = startCase(field).replace(/[^A-Za-z0-9]/g, "");
  trackEventUtil("Dispensary Reviews", action, label);
};
